import React, { useCallback, useEffect, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { NumberFilter } from '../filters/NumberFilter';
import { debounce } from 'lodash';

import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import Rating from '@mui/material/Rating';
import {PaidOutlined, PaidRounded} from "@mui/icons-material";

export const SPRateField: FieldComponent<number, string[]> = ({
  onChange,
  defaultValue,
  forcedValue,
  disabled,
  isMissing,
  column,
  columnName,
                                                                  withOutEndAdornment,
}) => {
  const [currentState, setCurrentState] = useState<any>({
    value: undefined,
    send: false,
  });

  const debouncedChange = useCallback(
    debounce((newValue) => {
      onChange(newValue);
    }, 300),
    []
  );

  useEffect(() => {
    if (defaultValue) {
      setCurrentState({
        value: defaultValue,
        send: false,
      });
    }
  }, [defaultValue]);

  useEffect(() => {

    if (forcedValue) {
      setCurrentState({
        value: forcedValue,
        send: false,
      });
    }
  }, [forcedValue]);

  useEffect(() => {
    if (currentState.send) {
      debouncedChange(currentState.value);
    }
  }, [currentState, debouncedChange]);

  const handleChange = (value: any) => {
    setCurrentState({
      value: value,
      send: true,
    });
  };

  return (
    <Rating
      value={typeof currentState.value === 'number' ? currentState.value : null}
      max={3}
      precision={1}
      onChange={(event, value) => handleChange(value)}
      icon={<PaidRounded fontSize="inherit" />}
      emptyIcon={<PaidOutlined fontSize="inherit" />}
      disabled={disabled}
    />
  );
};

SPRateField.includes = (query = [], value = NaN) =>
  query.length === 0 ||
  query.some((filter) => {
    const filterValue = parseFloat(filter);
    if (!isNaN(filterValue)) {
      return filterValue === value;
    }
    return false;
  });

SPRateField.comparator = (one, other) => {
  if (other === undefined) return -1;
  if (one === undefined) return 1;
  return one - other;
};

SPRateField.FilterRenderer = NumberFilter;
